module.exports = __webpack_public_path__ + "assets/img/1-2.36f3e70c.png";